import { Empty } from 'antd';
import React from 'react';
import Styles from './styles';
import { useClip } from '../../contexts/clip/hook';
import { ReactionLine } from '../ReactionLine';

const { ReactionsContainer, ReactionsListContainer, NoReactionsFoundContainer } = Styles;

export const Reactions: React.FC = () => {
  const { clip } = useClip();

  return (
    <ReactionsContainer>
      <ReactionsListContainer>
        {clip.reactions.map((reaction, index) => {
          return (
            <ReactionLine
              key={index}
              user={reaction.user}
              reaction={reaction.reaction}
              timestamp={reaction.timestamp}
              createdAt={reaction.createdAt}
            />
          );
        })}

        {clip.reactions.length === 0 && (
          <NoReactionsFoundContainer>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No reactions found" />
          </NoReactionsFoundContainer>
        )}
      </ReactionsListContainer>
    </ReactionsContainer>
  );
};
